import Plugin, { init } from "@/modules/_utils/Plugin";
import Swiper from "swiper";

export default () => {
  const productSlider = new Swiper("#product__swiper-container", {
    effect: "slide",
    grabCursor: true,
    slidesPerView: 3,
    spaceBetween: 30,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: true,
    simulateTouch: true,
    speed: 700,
    autoplay: {
      delay: 7000,
      disableOnInteraction: false
    },
    pagination: {
      el: ".swiper-pagination_product",
      clickable: false,
      renderBullet: function(index, className) {
        return '<span class="' + className + '"></span>';
      }
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    breakpoints: {
      575: {
        slidesPerView: 1
      },
      992: {
        slidesPerView: 2
      }
    }
  });
};
